import Create from "./Create";
import Edit from "./Edit";
import List from "./List";
import { SensorTypeIcon } from "../icons";

export default {
  options: {
    group: "types",
    accessible: ({ user }) =>
      user.role === "admin" &&
      user.permissions.indexOf("sensor-type/list") !== -1,
  },
  icon: SensorTypeIcon,
  list: List,
  edit: Edit,
  create: Create,
};
